import { format2Frontend } from "../Layers/util";
import { CREATE, DELETE, LIST, UPDATE } from "./actionsTypes";

const packingListsState = {
    items: false,
    isLoading: false,
    isUpdating: false,
    current: {},
    raw_json: false,
    existing_layers: false,
    list_id: false,
    step: 0,
    filter: { search: "", limit: 25, offset: 0, ordering: "" },
};

export default (state = packingListsState, action) => {
    switch (action.type) {
    case LIST.LOADING:
        return { ...state, isLoading: true };
    case LIST.SUCCESS:
        return { ...state,
            isLoading: false,
            items: {
                ...action.payload.data,
                results: action.payload.data.results.map((item) => ({
                    ...item,
                    ...(item.layer ? { layer: format2Frontend(item.layer) } : {})
                })),
            }
        };

    case CREATE.LOADING:
        return { ...state, isUpdating: true };
    case CREATE.RESET:
        return { ...state, raw_json: false, existing_layers: false, list_id: false, step: 0, import_data: false, growers_to_insert: [] };
    case CREATE.SUCCESS:
        return { ...state, isUpdating: false, raw_json: action.payload.data.preview, current: action.payload.data.list, existing_layers: action.payload.data.existing_layers, list_id: action.payload.data.list_id, growers_to_insert: action.payload.data.growers_to_insert };
    case CREATE.ERROR:
        return { ...state, isUpdating: false, raw_json: false, existing_layers: false, list_id: false, import_data: false, growers_to_insert: [] };

    case UPDATE.STEP:
        return { ...state, step: action.payload };
    case UPDATE.IMPORT_DATA:
        return { ...state, import_data: action.payload };

    case LIST.FILTER:
        return { ...state, filter: { ...state.filter, ...action.payload } };

    case DELETE.LOADING:
        return { ...state, isUpdating: true };
    case DELETE.SUCCESS:
        return { ...state, isUpdating: false, items: { results: state.items.results.filter((item) => item.id !== action.payload.data.id), count: state.count - 1 } };
    case DELETE.ERROR:
        return { ...state, isUpdating: false };

    default:
        return state;
    }
};
